import { Spin } from '@/components';
import type { FC } from 'react';

const Loading: FC = () => {
  return (
    <section className="flex gap-3 justify-center items-center w-full h-full">
      <Spin width={24} height={24} />
      <p className="text-sm text-secondary-2">加载中</p>
    </section>
  );
};

export default Loading;
